import React from "react";
import CaseBlock from './caseBlock';
import ClientGrid from "./clientGrid";
import FeatureBlockSection from './featureBlockSection';
import FooterBanner from './footerBanner';
import InformationGrid from './informationGrid';
import MixedRichText from './mixedRichText';
import SectionHeaderPill from "./sectionHeaderPill";
import CognitoForm from './cognitoFormSlice';

const SliceR = ({ data, classList = '', isAltBackground = false, ...args }) => {
  if (!data || typeof data.slice_type === "undefined") return null;

  const sliceProps = { ...args, data, isAltBackground };

  switch (data.slice_type.replace(/\d+$/, '')) {
    case "callout_box":
      return (
        <div className="box style-1">
          <h3 className="tag">{data.primary.callout_box_label.text || ""}</h3>
          <div className="callout-text" dangerouslySetInnerHTML={{ __html: data.primary.callout_box_body_text.html || "" }}></div>
          {data.primary?.callout_box_cta_link?.url && (
            <a href={data.primary.callout_box_cta_link.url} className="btn btn-primary">
              {data.primary.callout_box_cta_text} →
            </a>
          )}
        </div>
      )
    case "case_block":
      return <CaseBlock {...sliceProps} />
    case "client_grid":
      return <ClientGrid data={data} {...args} />
    case "feature_block_section":
      return <FeatureBlockSection data={data} {...args} />
    case "footer_banner":
      return <FooterBanner data={data} />
    case "form_id":
      return <CognitoForm id={data.primary.form_id} />
    case "information_grid":
      return <InformationGrid data={data} {...args} />
    case "mixed_rich_text":
      return <MixedRichText data={data} {...args} />
    case "section_header_pill":
      return <SectionHeaderPill data={data} {...args} />
    default:
      return null;
  }
}

export default SliceR;